import type { FunctionComponent } from 'react';
import cx from 'classnames';
import styles from './Settings.module.less';

type Props = {
  /**
   * The sizing option for the paragraph.
   */
  size?: 'small' | 'medium' | 'large';
};

/**
 * SettingsPageParagraph displays a paragraph of text on a settings page.
 * It has a size prop to control the sizing of the text and margin-bottom.
 */
const SettingsPageParagraph: FunctionComponent<Props> = ({ size = 'small', children }) => (
  <p className={cx(styles.paragraph, {
    [styles.paragraphSmall]: size === 'small',
    [styles.paragraphMedium]: size === 'medium',
    [styles.paragraphLarge]: size === 'large',
  })}>
    {children}
  </p>
);

export default SettingsPageParagraph;
